import * as Sentry from "@sentry/react";
import { reactRouterV5BrowserTracingIntegration } from "@sentry/react";
import history from "./history";
import {
  apiEndpoint,
  sentryTracesSampleRate,
  sentryDsn,
  insightoutAiEndpoint,
} from "./env";
import { getCurrentTenantDomain } from "./tenant";

export function initSentry() {
  if (!sentryDsn || window.Cypress) {
    return;
  }
  Sentry.init({
    dsn: sentryDsn,
    enableLogs: true,
    release: process.env.REACT_APP_GIT_SHA1,
    environment: process.env.REACT_APP_SENTRY_ENV,
    integrations: [reactRouterV5BrowserTracingIntegration({ history })],
    tracePropagationTargets: [apiEndpoint, insightoutAiEndpoint],

    // If this is 0, performance monitoring is disabled
    // but distributed tracing is not
    tracesSampleRate: sentryTracesSampleRate
      ? Number(sentryTracesSampleRate)
      : 0,
  });
  const domain = getCurrentTenantDomain();
  if (domain) {
    Sentry.setTag("tenant.domain", domain);
  }
}

export function showSentryReportDialog(data) {
  Sentry.showReportDialog(data);
}

export function setSentryUser(user) {
  Sentry.setUser(user);
  Sentry.getCurrentScope().setUser(user);
}
